import { render, staticRenderFns } from "./DmqProductActions.vue?vue&type=template&id=189b6fd4&"
import script from "./DmqProductActions.vue?vue&type=script&lang=ts&"
export * from "./DmqProductActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports